"use client";

import React from "react";
import { MenuItem as MenuItemType } from "./menuConfig";
import * as S from "./styles";

interface MenuItemProps {
  item: MenuItemType;
  locale: string;
  sidebarOpen: boolean;
  isActive: (path: string | undefined) => boolean;
  getLocalizedPath: (path: string) => string;
  isExpanded: boolean;
  onToggle: (categoryId: string) => void;
  onNavigate?: () => void;
}

export const MenuItemComponent: React.FC<MenuItemProps> = ({
  item,
  locale,
  sidebarOpen,
  isActive,
  getLocalizedPath,
  isExpanded,
  onToggle,
  onNavigate,
}) => {
  const hasSubItems = item.subItems && item.subItems.length > 0;

  if (hasSubItems) {
    return (
      <S.ItemList>
        <S.BoxItemAccordion>
          <S.ButtonAccordion
            onClick={() => onToggle(item.id)}
            $isActive={isExpanded}
          >
            <S.InfoNavigation>
              <S.IconNavigation>{item.icon}</S.IconNavigation>
              {sidebarOpen && <S.TextNavigation>{item.name}</S.TextNavigation>}
            </S.InfoNavigation>
            {sidebarOpen && <S.IconChevronDown />}
          </S.ButtonAccordion>

          {isExpanded && (
            <S.SubListNavigation $isOpen={sidebarOpen}>
              {item.subItems!.map((subItem) => (
                <S.SubItemNavigation key={subItem.path}>
                  <S.LinkNavigation
                    href={getLocalizedPath(subItem.path)}
                    $isActive={isActive(subItem.path)}
                    onClick={onNavigate}
                  >
                    <S.IconSubNavigation>{subItem.icon}</S.IconSubNavigation>
                    <S.SubTextNavigation>{subItem.name}</S.SubTextNavigation>
                  </S.LinkNavigation>
                </S.SubItemNavigation>
              ))}
            </S.SubListNavigation>
          )}
        </S.BoxItemAccordion>
      </S.ItemList>
    );
  }

  return (
    <S.ItemList>
      <S.LinkLost
        href={getLocalizedPath(item.path || "#")}
        $isActive={isActive(item.path)}
        onClick={onNavigate}
      >
        <S.InfoNavigation>
          <S.IconNavigation>{item.icon}</S.IconNavigation>
          {sidebarOpen && <S.TextNavigation>{item.name}</S.TextNavigation>}
        </S.InfoNavigation>
      </S.LinkLost>
    </S.ItemList>
  );
};
